import { apiResourceUrl } from "@ploy-lib/core";
export async function getCourseStatusResponse() {
    const response = await fetch(apiResourceUrl("user/courses/incomplete"));
    const res = response.json().then(r => {
        var data = r;
        console.log(data);
        return data;
    });
    return res;
}
//# sourceMappingURL=MissingCourseResource.js.map